import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '../components/ui/Button';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/** Error Boundary auf App-Ebene (NFR-003). Zeigt eine sachliche Fehlerseite ohne Stacktrace (ERR-001). */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error('Unerwarteter Anwendungsfehler:', error, info.componentStack);
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="page-container">
        <div className="card stack">
          <h1>Die Testdaten konnten nicht geladen werden.</h1>
          <p>Es ist ein unerwarteter Fehler aufgetreten. Bitte lade die Seite neu.</p>
          <Button onClick={() => window.location.reload()}>Neu laden</Button>
        </div>
      </div>
    );
  }
}
